import { USER_BASEURL_V6 } from "../utils/endpoint/baseUrl";
import { fetchWrapper } from "../utils/endpoint/fetch";
import { getHeaders } from "../utils/endpoint/header";

/**
 * Fetch the svod country id
 * @returns
 */
export const getLocation = (session: string, apiKey: string) => {
	let promise = new Promise((resolve, reject) => {
		fetchWrapper(USER_BASEURL_V6 + "location/svod", { method: "GET", headers: { ...getHeaders(true), Session: session, ApiKey: apiKey } })
			.then((resJson) => {
				resolve(resJson);
			})
			.catch((err) => reject(new Error(err)));
	});

	return promise;
};
